<script lang="ts">
</script>

<div class="w-full z-10 flex items-center">
    <div class="bg-white/10 w-full h-[1px]"></div>
</div>
